import {
  PatchApiSpoPosterExtractBody,
  PostApiSpoPosterBody,
  SpoPosterTableResponse,
} from '@spo/types';
import { apiBff } from '.';

export const getOfferPosterExtract = async (
  patchApiSpoPosterExtractBody: PatchApiSpoPosterExtractBody,
): Promise<BlobPart> => {
  return apiBff.callBFF(
    'POST',
    'spo/poster_extract',
    patchApiSpoPosterExtractBody,
    'blob',
  );
};

//TODO: delete this type once filters types are cerrectly implemented
// Duplicated type, because if I'm importing it from @spo/logic, there is circular dependencies issues...
export type FiltersRequestResponse = {
  productManagerIds: string[];
  productNatureIds: number[];
  retailFamilyIds: number[];
  segmentationIds: number[];
  sportIds: number[];
};

export const getOfferPoster = async (
  postApiSpoPosterBody: PostApiSpoPosterBody,
): Promise<SpoPosterTableResponse> => {
  return apiBff.callBFF('POST', 'spo/poster', postApiSpoPosterBody);
};
